import { NgModule } from '@angular/core';
import { PlusSvgComponent } from './plus-svg/plus.component';

@NgModule({
    declarations: [PlusSvgComponent],
    exports: [PlusSvgComponent],
})
export class SvgModule {}
